"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    name: "iso_9_1968_alt",
    description: "ISO/R 9:1968 transliteration schema",
    url: "https://dangry.ru/iuliia/iso-9-1968/",
    mapping: {
        а: "a",
        б: "b",
        в: "v",
        г: "g",
        д: "d",
        е: "e",
        ё: "ë",
        ж: "zh",
        з: "z",
        и: "y",
        й: "ĭ",
        к: "k",
        л: "l",
        м: "m",
        н: "n",
        о: "o",
        п: "p",
        р: "r",
        с: "s",
        т: "t",
        у: "u",
        ф: "f",
        х: "kh",
        ц: "ts",
        ч: "ch",
        ш: "sh",
        щ: "shch",
        ъ: "ʺ",
        ы: "y",
        ь: "ʹ",
        э: "ė",
        ю: "yu",
        я: "ya",
    },
    prev_mapping: null,
    next_mapping: null,
    ending_mapping: null,
    samples: [
        [
            "Юлия, съешь ещё этих мягких французских булок из Йошкар-Олы, да выпей алтайского чаю",
            "Yulyya, sʺeshʹ eshchë ėtykh myagkykh frantsuzskykh bulok yz Ĭoshkar-Oly, da vypeĭ altaĭskogo chayu",
        ],
    ],
};
